<template>
<div
  class="event-card"
  v-loading="!event"
>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6"><h4 class="card-title"><i class="ti-user"></i> Dados: {{label}}</h4></div>
        <div
          class="col-md-6 text-right"
          v-if="showEditButton"
        >
          <router-link :to="{name: 'events.edit', params: {id: event._id}}">
            <a
              v-if="$can('events.edit')"
              class="btn btn-fill btn-primary btn-sm btn"
            ><i class="ti-pencil"></i> Editar</a>
          </router-link>
        </div>
      </div>
    </div>
    <div class="card-content">
      <dl class="dl-horizontal">
        <dt>Município</dt>
        <dd>{{ event.city }}</dd>
        <dt>Referência</dt>
        <dd>{{ event.reference }}</dd>
        <dt>Local</dt>
        <dd>{{ event.place }}</dd>
        <dt>Data de Início</dt>
        <dd>{{ new Date(event.startDate).toISOString() | moment('L') }}</dd>
        <dt>Data de Fim</dt>
        <dd>{{ new Date(event.endDate).toISOString() | moment('L') }}</dd>
        <dt>Data da Cerimônia</dt>
        <dd>{{ new Date(event.dateTimeCeremony).toISOString() | moment('L') }}</dd>
        <dt>Nº de Refrigeradores</dt>
        <dd>{{ event.numberOfRefigerators }}</dd>
        <dt>Situação</dt>
        <dd>{{ event.present.status }}</dd>
        <dt>Criado por:</dt>
        <dd><strong>{{ users[event.userId] }}</strong></dd>
      </dl>
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EventCard',

  props: {
    event: {
      required: true,
      type: Object
    },
    showEditButton: {
      default: true
    }
  },

  computed: {
    ...mapGetters('users', { users: 'usersIdName' }),
    label () {
      return localStorage.getItem('eventLabel')
    }
  },

  methods: {
    ...mapActions('users', {
      fetchUsers: 'fetchAll'
    })
  },
  mounted () {
    this.fetchUsers({ limit: 999 })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Events/EventCard.vue